import React, {Component} from "react";
import Dialog from "@material-ui/core/Dialog";
import Transition from "../../../../../../../images/modals/check-in-transition.svg"
import IconCalendar from '../../../../../../../images/modals/iconCalendar.png'
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import AvatarButton from '../components/avn-button'
import Icon from '@material-ui/core/Icon';
import { modifyUser, insertWeighIn, resumeWeighIn } from "../../../../../../../api";
import { toDateString, hostDateToString, dateStringAddDays } from '../../../util'

import moment from 'moment'

const LBS_PER_KG = 2.204622

function validateWeight(weight, useMetric) {
  const inMetricRange = (weight <= 453.592 && weight >= 31.75)
  const inImperialRange = (weight <= 999 && weight >= 70)
  const isUsingMetric = (Number(useMetric) === 1)
  if (!(/^([0-9,.]{0,3})\d/.test(weight)) || ((isUsingMetric) ? !inMetricRange : !inImperialRange) || !weight || weight.length > 8)
    return 'Invalid weight'
}

function validateBodyFat(bodyFat, gender) {
  const inRangeMale = (Number(bodyFat) >= 3 && Number(bodyFat) <= 60)
  const inRangeFemale = (Number(bodyFat) >= 8 && Number(bodyFat) <= 65)

  if ((!inRangeMale && gender === 'MALE') || (!inRangeFemale && gender === 'FEMALE') || bodyFat.length > 5)
    return 'Invalid body fat percentage'
}

export default class CheckinFormPortal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitDisabled: false,
      overridingAverage: true,
      showOverrideModal: false,
      weight: this.props.previousWeight ? this.props.previousWeight : '',
      body_fat: this.props.previousBodyfat ? this.props.previousBodyfat : '',
      isCompliant: 0,
      estimatedWeight: '',
      isNearPeriod: '',
      isRetainingFluid: '',
      shouldIgnoreWeightGain: '',
      skipNearPeriod: null,
      width: window.innerWidth,
      showBFModal: false,
      isSubmitting: false,
      showQuestionsError: false,
      showCheckinForm: false,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.previousWeight !== prevProps.previousWeight || this.props.previousBodyfat !== prevProps.previousBodyfat) {
      this.setState({
        weight: `${this.props.previousWeight}`,
        body_fat: `${this.props.previousBodyfat}`,
      })
    }
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  getSkipNearPeriod = () => {
    let skipNearPeriod
    if (this.state.skipNearPeriod !== null) {
      skipNearPeriod = this.state.skipNearPeriod
    } else if (this.props.gender === 'FEMALE' && this.state.isNearPeriod === 0 && this.props.skipNearPeriod === 0) {
      skipNearPeriod = 2
    } else {
      skipNearPeriod = this.props.skipNearPeriod
    }
    return skipNearPeriod
  }

  renderMenstrual = () => {
    const skipNearPeriod = this.getSkipNearPeriod()
    return (
      <>
        <h4 className="content-header">Menstrual cycle</h4>
        <label>Are you within 5 days of starting your period?</label>
        <div className='check-in-button-group'>
          <button className={(this.state.isNearPeriod === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({isNearPeriod: 1})}>Yes</button>
          <button className={(this.state.isNearPeriod === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({isNearPeriod: 0})}>No</button>
        </div>

        {this.state.isNearPeriod === 1 &&
          <>
            <label>Do you think that you may be retaining fluid weight?</label>
            <div className='check-in-button-group'>
              <button className={(this.state.isRetainingFluid === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ isRetainingFluid: 1 })}>Yes</button>
              <button className={(this.state.isRetainingFluid === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ isRetainingFluid: 0 })}>No</button>
            </div>
          </>
        }
        {this.state.isNearPeriod === 0 && this.props.skipNearPeriod === 0 &&
          <>
            <label>Do you want to skip this menstrual question from now on? (You can change it back in preferences)</label>
            <div className='check-in-button-group'>
              <button className={(skipNearPeriod === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ skipNearPeriod: 1 })}>Yes</button>
              <button className={(skipNearPeriod === 2) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ skipNearPeriod: 2 })}>No</button>
            </div>
          </>
        }
        {(this.state.isCompliant === 1 && this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1) &&
          this.shouldApplyStandardIncrease()
        }
        {(this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && this.state.isCompliant === 0) &&
          <>
            <label>Estimate your most recent weight that was not affected by your menstrual cycle:</label>
            <input name='estimatedWeight' value={this.state.estimatedWeight} onChange={this.handleChange}/>
            <label>{this.props.useMetricUnits ? 'Kilograms' : 'Pounds'}</label>
          </>
        }
      </>
    )
  }

  shouldApplyStandardIncrease = () => {
    if(this.props.goal && this.props.goal === 'REVERSE DIETING') {
      return (
        <>
          <label>Since your menstrual cycle may be artificially increasing your weight this week, we will apply the typical adjustment to your macros even if you exceeded the limit defined by your goal. Is this okay?</label>
          <div className='check-in-button-group'>
            <button className={(this.state.shouldIgnoreWeightGain === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 1 })}>Yes</button>
            <button className={(this.state.shouldIgnoreWeightGain === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 0 })}>No</button>
          </div>
        </>
      )
    } else {
      return (
        <>
          <label>Since your menstrual cycle may be artificially increasing your weight this week, we will not adjust your macros if you fell short of your goal. Is this okay?</label>
          <div className='check-in-button-group'>
            <button className={(this.state.shouldIgnoreWeightGain === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 1 })}>Yes</button>
            <button className={(this.state.shouldIgnoreWeightGain === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 0 })}>No</button>
          </div>
        </>
      )
    }
  }

  handleSubmit = (e) => {
    let estimatedWeight = null;
    const effectiveWeight = this.state.weight
    const wError = validateWeight(effectiveWeight, this.props.useMetricUnits);
    const bfError = validateBodyFat(this.state.body_fat, this.props.gender);

    if(wError) {
      this.props.openFeedback('Invalid weight', true)
      return
    } else if (bfError) {
      this.props.openFeedback('Invalid body fat percentage', true)
      return
    }

    if(this.state.estimatedWeight)
      estimatedWeight = (this.props.useMetricUnits) ? Number(this.state.estimatedWeight) : Number(this.state.estimatedWeight) / LBS_PER_KG;

    if(this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && (this.state.isCompliant !== 1 || this.state.shouldIgnoreWeightGain === 1) && !estimatedWeight) {
      this.props.openFeedback('Please enter an estimated weight', true)
      // this.setState({ showSnackbar: true, response: 'Please enter an estimated weight.' });
      return;
    }

    this.setState({ isSubmitting: true, submitDisabled: true })

    if(this.props.vacationSetting) {
      resumeWeighIn(
        this.props.userId,
        this.props.portalId,
        (this.props.useMetricUnits) ? effectiveWeight : effectiveWeight / LBS_PER_KG,
        this.state.body_fat,
        (this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1) ? 1 : 0,
        0,
        estimatedWeight
      ).then(() => {
        this.setState({ isSubmitting: false, submitDisabled: false, showCheckinForm: false })
        this.props.onClose()
        this.props.openFeedback('Check-in has been added, and vacation setting is updated', false)
        this.props.loadPortalAccount()
      }).catch((err) => {
        this.props.openFeedback('Check-in encountered an error', true)
      })

    } else if (this.props.goalCheckin) {
      const req = {
        weighin: {
          weight: (this.props.useMetricUnits) ? Number(this.state.weight) : Number(this.state.weight) / LBS_PER_KG,
          estimated_weight: estimatedWeight,
          body_fat: this.state.body_fat,
          compliant: 0,
          near_period: (this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && (this.state.isCompliant !== 1 || this.state.shouldIgnoreWeightGain === 1)) ? 1 : 0,
          local_today: toDateString(new Date())
        },
        skip_near_period: 0,
        goal: this.props.goal,
        ...this.props.goalLevelInfo
      }

      modifyUser(this.props.userId, this.props.portalId, req).then(() => {
        this.setState({ isSubmitting: false, submitDisabled: false, showCheckinForm: false })
        this.props.loadPortalAccount();
        this.props.closeGoalModal();
        this.props.openFeedback('Goal change successful!', false)
      }).catch((res) => {
        this.setState({ isSubmitting: false })
        this.props.openFeedback('Failed to change goal', true)
      })
    } else if (this.props.editCheckin) {
      console.log('test')
    } else {
      insertWeighIn(
        this.props.userId,
        this.props.portalId,
        (this.props.useMetricUnits) ? effectiveWeight : effectiveWeight / LBS_PER_KG,
        this.state.body_fat,
        (this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && (this.state.isCompliant !== 1 || this.state.shouldIgnoreWeightGain === 1)) ? 1 : 0,
        0,
        null,
        0,
        0,
        {},
        estimatedWeight
      ).then(() => {
        this.setState({ isSubmitting: false, submitDisabled: false, showCheckinForm: false })
        this.props.openFeedback('Check-in has been added', false)
        this.props.loadPortalAccount()
      }).catch((err) => {
        this.setState({ isSubmitting: false, submitDisabled: false })
        this.props.openFeedback('Check-in encountered an error', true)
      })
    }
  }

  getDisplayLabel = (date) => {
    return moment(date).calendar(null, {
      sameDay: '[Today], MMM Do',
      nextDay: '[Tomorrow], MMM Do',
      nextWeek: 'ddd, MMM Do',
      lastDay: '[Yesterday], MMM Do',
      lastWeek: 'ddd, MMM Do',
      sameElse: 'ddd, MMM Do',
    });
  }

  getNextCheckInDate = () => {
    // Use today as the lastWeighInDateTemp (as specified)
    const todayTemp = new Date();
    const today = new Date(todayTemp.getFullYear(), todayTemp.getMonth(), todayTemp.getDate());
    
    // Default check-in date (7 days from today)
    let userCheckinDate = hostDateToString(today);
    userCheckinDate = dateStringAddDays(userCheckinDate, 7);
    
    // Calculate nextPossibleWeighInDate (today + 5 days or today, whichever is later)
    const todayPlus5Days = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 5);
    const nextPossibleWeighInDate = new Date(todayPlus5Days.valueOf() > today.valueOf() ? todayPlus5Days.valueOf() : today.valueOf());
    
    // If user has a check_in_date preference, use it to determine the day of week
    if (this.props.checkInDate) {
      const checkInDateTemp = new Date(this.props.checkInDate);
      const checkInDate = new Date(
        checkInDateTemp.getUTCFullYear(),
        checkInDateTemp.getUTCMonth(),
        checkInDateTemp.getUTCDate()
      );
      const desiredDayOfWeek = checkInDate.getDay();
      let dayOffset = desiredDayOfWeek - nextPossibleWeighInDate.getDay();
      if (dayOffset < 0) {
        dayOffset += 7;
      }
      const desiredNextWeighInDate = new Date(
        nextPossibleWeighInDate.getFullYear(),
        nextPossibleWeighInDate.getMonth(),
        nextPossibleWeighInDate.getDate() + dayOffset
      );

      userCheckinDate = hostDateToString(desiredNextWeighInDate);
    }
    
    return userCheckinDate;
  }

  getFormattedNextCheckInDate = () => {
    const nextCheckInDateString = this.getNextCheckInDate();
    const nextCheckInDate = moment(nextCheckInDateString);
    return nextCheckInDate.format('dddd, MMM Do');
  }

  render() {

    let formattedLastWeighInDate = moment.utc()
    formattedLastWeighInDate = formattedLastWeighInDate.subtract(this.props.daysAfterLastCheckIn, "days");
    formattedLastWeighInDate = formattedLastWeighInDate.format('MMM D, YYYY')

    return (
      <>
        <Dialog
          open={this.props.skipMessage ? false : this.props.open}
          onClose={this.props.onClose}
        >
          <DialogContent className='avn-modal-content-container'>
            <p style={{padding: '12px 0px'}}>Since the user last checked in {this.props.daysAfterLastCheckIn} days ago, you’ll need to enter a new starting weight for them so we can see the effect that this setting change has on their body.</p>
            <p style={{display: 'flex', alignItems: 'center', padding: '12px 0px', maxWidth: '400px', color: '#e8012c'}}><Icon style={{marginRight: 8}}>error</Icon>The user's next check-in would also be pushed back to {this.getFormattedNextCheckInDate()}.</p>
            <DialogActions className='avn-modal-actions-container'>
              <button className='avn-modal-action' onClick={() => {this.setState({showCheckinForm: true});  this.props.onClose();}}>Check in</button>
              <button className='avn-modal-action-cancel' onClick={this.props.onClose}>Close</button>
            </DialogActions>
          </DialogContent>
        </Dialog>

        
        <Dialog
          className="check-in-dialog"
          fullScreen
          open={this.props.skipMessage ? this.props.open : this.state.showCheckinForm}
          onClose={() => { this.props.skipMessage ? this.props.onClose() : this.setState({showCheckinForm: false}) }}
        >
          <div className="check-in-close">
            <button onClick={() => { this.props.skipMessage ? this.props.onClose() : this.setState({showCheckinForm: false}) }}>
              <Icon>close</Icon>
            </button>
          </div>
          <div className="check-in-dialog">
            <div className="check-in-header">
              <h3>{this.props.editCheckin ? 'Edit Check-in' : 'Check-in'}</h3>
              <img src={Transition} alt="wave" />
            </div>
            <div className="check-in-content">
              <div className="check-in-date">
                <img src={IconCalendar} alt="calendar" />
                <p>{this.props.editCheckin ? formattedLastWeighInDate : this.getDisplayLabel()}</p>
              </div>

              <h4 className="content-header">Weight</h4>
              <label>Most recent weight: <span style={{color: '#14ab40'}}>{this.props.weightString} ({formattedLastWeighInDate})</span></label>

              <input name='weight' type='number' value={this.state.weight} onChange={this.handleChange}/>
              <label>{this.props.useMetricUnits ? 'Kilograms' : 'Pounds'}</label>
              
              <h4 className="content-header">Body fat percentage</h4>
              <label>Most recent body fat percentage: <span style={{color: '#14ab40'}}>{this.props.previousBodyfat}% ({formattedLastWeighInDate})</span></label>
              <input name='body_fat' type='number' value={this.state.body_fat} onChange={this.handleChange}/>

              {this.props.gender === 'FEMALE' && this.renderMenstrual()}   

              {!this.props.editCheckin && <p style={{display: 'flex', alignItems: 'center', padding: '24px 0px 0px 0px', color: '#e8012c'}}><Icon style={{marginRight: 8}}>error</Icon>The user's next check-in will be pushed back to {this.getFormattedNextCheckInDate()}.</p>}
              <button
                className="check-in-dialog-submit"
                onClick={this.handleSubmit}
                disabled={this.state.submitDisabled}
              >
                Save Check-in
              </button>
            </div>
          </div>
        </Dialog>
      </>
    );
  }
};
